// extracted by mini-css-extract-plugin
export var iIcon = "tooltip-module--iIcon--3714a";
export var tooltips = "tooltip-module--tooltips--5c431";